import responseImage from "../../models/response/image";

export default {
  new(item) {
    this.name = item.name;
    this.slug = item.slug;
    this.is_active = item.is_active === 1;
    this.is_micro_site = item.is_micro_site === 1;
    this.types = item.types;
    this.description = {
      text: item.description,
      show: item.show_description === 1,
      place: item.description_place ? item.description_place : "before",
    };
    this.title = item.title;
    this.sub_title = item.sub_title;
    this.embed_url = item.embed_url;

    this.meta = {
      title: item.meta_title,
      keywords: item.meta_keywords,
      description: item.meta_description,
      robots: ["index", "follow"], //item.meta_robots ? item.meta_robots.split(", ") : [],
      canonicalUrl: item.canonical_url,
    };
    this.image.files = [responseImage.clone(item.image, false)];
    this.mobile_image.files = [
      responseImage.clone(item.mobile_image, false),
    ];

    return this;
  },
  image: {
    files: [],
    filesData: null,
  },
  mobile_image: {
    files: [],
    filesData: null,
  },
};
